/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { Checkbox, Label, Stack } from "@fluentui/react";

export interface IAuditProps {
    auditChanges: boolean;
    onAuditChangesChanged: (checked: boolean) => void;
}

const Audit = (props: IAuditProps): JSX.Element => {
    const onChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (checked !== undefined) {
            props.onAuditChangesChanged(checked);
        }
    };

    return (
        <Stack>
            <Label>Audit</Label>
            <Checkbox label="Audit changes" checked={props.auditChanges} onChange={onChange} />
        </Stack>
    );
};

export default Audit;
